import angular from 'angular';
import uib from 'angular-ui-bootstrap';
import cmsAuthService from './CMSAuthService';
import httpAuthInterceptor from 'angular-http-auth';



/**
 * Service - auth dialog manager
 * @param $uibModal
 * @returns {{}}
 */
let AuthDialogService = function ($uibModal) {

    let service = {};

    service.open = function () {

        $uibModal.open({
            animation: true,
            template: require('./authDialog.html'),
            size: 'md',
            backdrop: 'static',
            controllerAs: 'vm',
            controller: function ($uibModalInstance, authService, CMSAuthService) {

                let vm = {};

                vm.login = function () {
                    vm.loginError = false;
                    vm.loginPending = true;
                    CMSAuthService.reLogin(vm.password).then(function (data) {
                        if (data.success) {
                            // Angular-http-auth: rerun requests
                            authService.loginConfirmed('success', function (config) {
                                config.headers["Authorization"] = "JWT " + CMSAuthService.getToken();
                                return config;
                            });
                            $uibModalInstance.close();
                        } else {
                            vm.loginError = true;
                            vm.loginPending = false;
                        }
                    })
                };

                vm.logout = function () {
                    CMSAuthService.logout(function () {
                        window.location.href = "/login.html";
                    });
                };

                return vm;
            }
        });
    };

    return service;

};

/**
 * Module responsible for re-login dialog
 * @namespace cms.auth.dialog
 */
export default angular.module('cms.auth.dialog', [
    uib,
    cmsAuthService,
    httpAuthInterceptor]).factory('AuthDialogService', AuthDialogService).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Auth/AuthDialogService.js